if (!customElements.get('product-store-links')) {
	class ProductStoreLinks extends HTMLElement {
		static SELECTORS = {
			ACTIVE_LABEL: 'product-links-container--active',
			LABEL: 'product-links-container',
			HIDDEN: 'hidden',
			FIND_IN_STORE_BUTTON: 'product-links__find',
			STORE_LOCATOR: 'storepoint-container',
		};
		constructor() {
			super();
			this.checkExistingStoreLocator();
			this.elements = {
				active_label: this.querySelector(`.${ProductStoreLinks.SELECTORS.ACTIVE_LABEL}`),
				labels: this.querySelectorAll(`.${ProductStoreLinks.SELECTORS.LABEL}`),
			};
			if (this.elements.labels.length < 2) {
				return;
			}
			const VARIANT_CHANGE_EVENT = 'variant_change';
			document.addEventListener(VARIANT_CHANGE_EVENT, (event) => {
				this.handleLabelChange(event.detail.id);
			});
		}
		checkExistingStoreLocator() {
			waitForElement(`#${ProductStoreLinks.SELECTORS.STORE_LOCATOR}`).then(() => {
				const findInStoreButtons = document.querySelectorAll(`.${ProductStoreLinks.SELECTORS.FIND_IN_STORE_BUTTON}`);
				findInStoreButtons.forEach((btn) => {
					btn.classList.remove(ProductStoreLinks.SELECTORS.HIDDEN);
				});
			});
		}
		handleLabelChange(variantId) {
			for (const label of this.elements.labels) {
				if (label.dataset.variant === variantId.toString()) {
					this.elements.active_label.classList.remove(ProductStoreLinks.SELECTORS.ACTIVE_LABEL);
					this.elements.active_label.ariaHidden = 'true';
					this.elements.active_label = label;
					this.elements.active_label.classList.add(ProductStoreLinks.SELECTORS.ACTIVE_LABEL);
					this.elements.active_label.ariaHidden = 'false';
					return;
				}
			}
		}
	}
	customElements.define('product-store-links', ProductStoreLinks);
}
